//natives
import React from 'react';
import CircularProgress from "@material-ui/core/CircularProgress";

//components
import Table from "../../../../../../../util/Table/.mixins/Table";
import Filter from "../../../../../../../util/filter/.mixins/Filter";
import Error from "../../../../../../../util/error/.mixins/Error";

export default function PermissoesLista(props) {
    return (
        <div className="container">
            {props.state.isLoading &&
                <div align="center">
                    <CircularProgress/>
                </div>
            }
            {!props.state.isLoading && !props.state.isError &&
                <div>
                    {/* <Filter {...props}/> */}
                    <br/>
                    <Table {...props}/>
                </div>
            }
            {props.state.isError &&
                <div align="center">
                    <Error text={props.state.error}/>
                </div>
            }
        </div>
    );
}